_getTrackHandler